import React from 'react';
import Style from './alert.module.css';
/** @jsxImportSource @emotion/react */

import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";

const Alert = props => {
  const propsArray = [];
  propsArray.className = props.className === undefined ? '' : props.className;
  propsArray.color = Style[props.color === undefined ? 'success' : props.color];
  propsArray.position = Style[props.position === undefined ? 'bottomRight' : props.position];
  let emotionStyle = [];

  if (props.ms !== undefined) {
    emotionStyle = props.ms;
  }

  const close = () => {
    let alert = document.querySelectorAll(`.${Style.alert}`);
    alert.forEach(obj => {
      obj.classList.add('d-none');
    });
  };

  return _jsxs(React.Fragment, {
    children: [propsArray.className === '' && _jsxs("div", {
      className: `${Style.alert} ${propsArray.color} ${propsArray.position}`,
      css: emotionStyle,
      children: [props.children, _jsxs("svg", {
        onClick: close,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        children: [_jsx("path", {
          d: "M9.172 16.242 12 13.414l2.828 2.828 1.414-1.414L13.414 12l2.828-2.828-1.414-1.414L12 10.586 9.172 7.758 7.758 9.172 10.586 12l-2.828 2.828z"
        }), _jsx("path", {
          d: "M12 22c5.514 0 10-4.486 10-10S17.514 2 12 2 2 6.486 2 12s4.486 10 10 10zm0-18c4.411 0 8 3.589 8 8s-3.589 8-8 8-8-3.589-8-8 3.589-8 8-8z"
        })]
      })]
    }), propsArray.className !== '' && _jsxs("div", {
      className: `${Style.alert} ${propsArray.color} ${propsArray.position} ${propsArray.className}`,
      css: emotionStyle,
      children: [props.children, _jsxs("svg", {
        onClick: close,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        children: [_jsx("path", {
          d: "M9.172 16.242 12 13.414l2.828 2.828 1.414-1.414L13.414 12l2.828-2.828-1.414-1.414L12 10.586 9.172 7.758 7.758 9.172 10.586 12l-2.828 2.828z"
        }), _jsx("path", {
          d: "M12 22c5.514 0 10-4.486 10-10S17.514 2 12 2 2 6.486 2 12s4.486 10 10 10zm0-18c4.411 0 8 3.589 8 8s-3.589 8-8 8-8-3.589-8-8 3.589-8 8-8z"
        })]
      })]
    })]
  });
};

export default Alert;